import { useState } from 'react';
import { useRegions } from '../hooks/useRegions';
import type { Region } from '../types/regions.types';
import { TreeNode } from './TreeNode';

interface RegionsTreeViewProps {
  onViewDetail?: (regionId: string) => void;
  onEdit?: (regionId: string) => void;
  onToggleStatus?: (regionId: string, regionName: string, currentIsActive: boolean) => void;
  onAddChild?: (regionId: string) => void;
  onDelete?: (regionId: string, regionName: string) => void;
}

export function RegionsTreeView({
  onViewDetail,
  onEdit,
  onToggleStatus,
  onAddChild,
  onDelete,
}: RegionsTreeViewProps) {
  const [expandedNodes, setExpandedNodes] = useState<Set<string>>(new Set());

  const { regions, isLoading } = useRegions({ pageSize: 100 });

  const handleToggle = (regionId: string) => {
    setExpandedNodes((prev) => {
      const next = new Set(prev);
      if (next.has(regionId)) {
        next.delete(regionId);
      } else {
        next.add(regionId);
      }
      return next;
    });
  };

  if (isLoading) {
    return <div className="py-12" aria-hidden />;
  }

  if (regions.length === 0) {
    return (
      <div className="flex items-center justify-center py-12 text-primary">
        No hay regiones configuradas
      </div>
    );
  }

  return (
    <div className="w-full" data-testid="regions-tree-view">
      {regions.map((region: Region) => (
        <TreeNode
          key={region.id}
          region={region}
          level={region.selector}
          expandedNodes={expandedNodes}
          onToggle={handleToggle}
          onViewDetail={onViewDetail}
          onEdit={onEdit}
          onToggleStatus={onToggleStatus}
          onAddChild={onAddChild}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
}
